export interface IOpenAvatarLightboxDetail {
  userName: string;
  avatarUrl?: string | null;
}

// Globalny "event bus" zgodny z resztą kodu (window.dispatchEvent).
export function openAvatarLightbox(detail: IOpenAvatarLightboxDetail) {
  window.dispatchEvent(new CustomEvent('openAvatarLightbox', { detail }));
}
